import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { QRCodeSVG } from 'qrcode.react';
import { useEffect, useState } from 'react';
import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';

type DialogFormType = {
  open: boolean;
  answerToken: string | null;
  handleShow: () => void;
  handleClose: () => void;
};

const DialogQRCode: React.FC<DialogFormType> = (props) => {
  const [timeLeft, setTimeLeft] = useState(30 * 60);
  const [updateTime, setUpdateTime] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!props.open) return;

    const handleCreate = async () => {
      handleUpdate();
    };

    handleCreate();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open]);

  useEffect(() => {
    if (!props.open) return;

    setTimeLeft(30 * 60);

    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [props.open, updateTime]);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60)
      .toString()
      .padStart(2, '0');
    const secs = (seconds % 60).toString().padStart(2, '0');
    return `このQRコードは${mins}:${secs}分に無効になります。`;
  };

  const handleUpdate = async () => {
    setIsLoading(true);
    try {
      await props.handleShow();
      setUpdateTime(Date.now());
      console.log(Date.now());
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    props.handleClose();
  };

  if (isLoading) {
    return (
      <Dialog
        open={props.open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogContent sx={{ width: '500px' }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <Typography fontSize={'16px'}>QRコードを生成中...</Typography>
          </Stack>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogContent sx={{ width: '500px' }}>
        <Stack justifyContent={'center'} alignItems={'center'}>
          <Typography mb={'20px'} fontSize={'16px'}>
            {'QRコードを読み取り、回答画面を開いてください。'}
          </Typography>
          {timeLeft === 0 ? (
            <Typography fontSize={'16px'} color={'#ED5565'}>
              QRコードは無効です。
            </Typography>
          ) : (
            <QRCodeSVG value={`${process.env.REACT_APP_CUSTOMER_APP_URL}/inclinic/questions/form?token=${props.answerToken}&time=${updateTime}`} />
          )}

          <Typography mt={'20px'} fontSize={'16px'}>
            {formatTime(timeLeft)}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: '20px', justifyContent: 'center' }}>
        <BtnGradient text='更新' handleButtonClick={handleUpdate} />
        <BtnOutlineGradient text='閉じる' handleButtonClick={handleClose} />
      </DialogActions>
    </Dialog>
  );
};

export default DialogQRCode;
